import { motion } from 'framer-motion'

const Tabs = ({ tabs, activeTab, setActiveTab }) => {
	const handleTabClick = (id) => {
		setActiveTab(id)
	}

	return (
		<div className="tabs" data-tabs >
			{tabs.map((tab) => {
				const isActive = activeTab === tab.id

				return (
					<div
						key={tab.id}
						className={`tab`}
						data-tab={tab.id}
						onClick={() => handleTabClick(tab.id)}
					>
						{isActive && (
							<motion.div
								layoutId="tabHighlight"
								className="absolute inset-0 rounded-[4px] bg-primary/faded"
								transition={{
									type: 'spring',
									stiffness: 500,
									damping: 35,
								}}
							/>
						)}
						<span className={`relative z-10 ${isActive && 'text-primary font-semibold'}`}>
							{tab.label}
						</span>
					</div>
				)
			})}
		</div>
	)
}

export default Tabs
